module.exports = __webpack_public_path__ + "static/media/iphone_12_mini_black.7022c328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_mini_black.png
// module id = 2082
// module chunks = 0